import MicroModal from "micromodal";

const isHomepage = window.location.pathname === "/";
const currentSite =
  window.location.pathname === "/"
    ? SITEBASEURL
    : new URL(window.location.pathname, SITEBASEURL).toString();

export default function (sparkThemeConfig) {
  const splashPageActive = sparkThemeConfig[4].showSplashPage;

  const fairgroundsThemeUrl = "";
  const fairgroundsThemeText =
    "South Florida Fair & Palm Beach County Expositions";

  const yyearThemeUrl = sparkThemeConfig[1].navItemUrl;
  const yyearThemeName = sparkThemeConfig[1].navItemName;

  const sFloridaThemeUrl = sparkThemeConfig[2].navItemUrl;
  const sFloridaThemeName = sparkThemeConfig[2].navItemName;

  const splashPageTemplate = `
    <div class="micromodal-slide" id="splashPage" aria-hidden="true">
    <div class="modal__overlay">
      <div class="modal__container splashPage" role="dialog" aria-modal="true" aria-labelledby="splash-title">
        <div class="overlay" tabindex="0">
          <div class="overlay-image base-bg"></div>
          <div class="overlay-image fair-site"></div>
          <div class="overlay-image sflorida-site"></div>
          <div class="overlay-image yesteryear-site"></div>
          <div class="overlay-color"></div>
        </div>
        <span id="splash-title" class="splash-title">Choose your destination</span>
        <div class="inner-content">
          <a href="${fairgroundsThemeUrl}" class="site-logo fair-site" aria-label="${fairgroundsThemeText}"
            title="${fairgroundsThemeText}">
            <div class="logo-image"></div>
          </a>
          <a href="${sFloridaThemeUrl}" class="site-logo sflorida-site" aria-label="${sFloridaThemeName}"
            title="${sFloridaThemeName}">
            <div class="logo-image"></div>
          </a>
          <a href="${yyearThemeUrl}" class="site-logo yesteryear-site" aria-label="${yyearThemeName}"
            title="${yyearThemeName}">
            <div class="logo-image"></div>
          </a>

        </div>
      </div>
    </div>
  </div>
`;

  function initModal() {
    appendSplashPage(splashPageTemplate, splashPageActive);

    function escBlocker(e) {
      if (e.key === "Escape") {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }

    document.addEventListener("keydown", escBlocker, true);

    MicroModal.init({
      disableScroll: true,
      disableFocus: true,
      awaitCloseAnimation: true,
      disableClose: true,
    });

    MicroModal.show("splashPage");

    detectUrl();
  }

  if (splashPageActive) {
    if (!getSessionSplash() && isHomepage) {
      initModal();
    }
  }

  $("#splashPage a").each(function () {
    $(this).on("mouseenter focus", function () {
      const classItem = $(this).attr("class").split(" ")[1];
      $("body").addClass(`${classItem}__show`);
    });

    $(this).on("mouseleave blur", function () {
      const classItem = $(this).attr("class").split(" ")[1];
      $("body").removeClass(`${classItem}__show`);
    });
  });

  setTimeout(() => {
    document.activeElement.blur();
  }, 0);
}

function setSessionSplash() {
  sessionStorage.setItem("splashPage", true);
}

function getSessionSplash() {
  return !!sessionStorage.getItem("splashPage");
}

function appendSplashPage(splash, splashPageActive) {
  if (splashPageActive) {
    $("body").prepend(splash);
    $("body").addClass("splashPage");
  }
}

function detectUrl() {
  $("#splashPage .site-logo").on("click", function (e) {
    setSessionSplash();
    e.preventDefault();
    const url = $(this).attr("href");

    if (currentSite === `${SITEBASEURL}${url}`) {
      fadeOutModal();
    } else {
      window.location.href = `${SITEBASEURL}${url}`;
    }
  });
}

function fadeOutModal() {
  $("#splashPage").css("opacity", "0");
  $("body").removeClass("splashPage");

  setTimeout(() => {
    $("#splashPage").remove();
  }, 800);
} //
